module.exports = __webpack_public_path__ + "8c6c83d379bd0e310a1b681a677fab1d.svg";